import {put,takeLatest,call} from 'redux-saga/effects';
import * as authService from '../../../services/authService'

import {
  REGISTER_FACEBOOK,
  REGISTER_FACEBOOK_SUCCESS,
  REGISTER_FACEBOOK_ERROR
}
  from "../../actions/auth";

function* registerFacebookSaga(action) {
  try {
    const data = yield call(authService.RegisterFacebook,action.payload)

    yield put({
      type: REGISTER_FACEBOOK_SUCCESS,
      payload: {userData: data}
    });


  } catch(error) {

    yield put({type: REGISTER_FACEBOOK_ERROR,error: error.data});
  }
}


export function* registerFacebookWatcher() {
  yield takeLatest(REGISTER_FACEBOOK,registerFacebookSaga);
}